import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21,3.62V9.75a9.39,9.39,0,1,1-12.28.43V3.86A14.65,14.65,0,1,0,21,3.62Z"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: "12.51",
  y: "0.46",
  width: "4.95",
  height: "16.99"
});

export default createSvgIcon(stroke => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30.23 32.16"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, _ref, /*#__PURE__*/React.createElement("path", {
  d: "M15.12,32.16A15.11,15.11,0,0,1,8.53,3.45l.66-.32v7.25L9,10.52a8.92,8.92,0,1,0,11.68-.42L20.55,10v-7l.64.29a15.11,15.11,0,0,1-6.07,28.95ZM8.28,4.61A14.08,14.08,0,0,0,.91,17.05,14.21,14.21,0,1,0,21.46,4.34V9.53A9.85,9.85,0,1,1,8.28,10Z",
  fill: stroke
}), _ref2, /*#__PURE__*/React.createElement("path", {
  d: "M17.92,17.91H12.05V0h5.87ZM13,17h4V.91H13Z",
  fill: stroke
}))))), 'Power');